module.exports = __webpack_public_path__ + "img/turkey-tamale-pie.2ea89b76.jpg";